import(/* webpackMode: "eager" */ "/data/airight-web3-fe/src/contents/marketplace/index.tsx")